import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { RestService } from 'src/app/services/rest-service';
import { AppSettings } from 'src/app/shared/app-settings';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EditDeleteRendererComponent } from '../../components/edit-delete-renderer/edit-delete-renderer.component';
import { ConfirmationDialogueComponent } from '../../components/confirmation-dialogue/confirmation-dialogue.component';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.css']
,
  standalone: false
})
export class UserManagementComponent implements OnInit {
  rolesList: any = [];
  usersList: any = [];
  gridOptions: any;
  columnDefs: any;
  rowData: any;
  defaultColDef: any;
  domLayout = '';
  userEmail: any = '';
  firstName: string = '';
  lastName: string = '';
  modalRef: NgbModalRef;
  action = '';
  userId: any;
  savedRoles: any;
  popupHeading;
  searchValue: any;
  dataBeforeEdit: any;
  savedRoleNames: string[] = [];

  @ViewChild('addUser', { static: false }) aduser: ElementRef<any>;
  model: any;
  constructor( private titleService: Title,public restService: RestService,
    private ngbModalService: NgbModal,
    private modalService: NgbModal, public spinner: SpinnerService,
    private toastr: ToastrService) {
    this.titleService.setTitle("User Management");
    this.domLayout = "autoHeight"

  }

  ngOnInit(): void {
    this.getUsers();
    this.getRoles();
    let title = this.titleService.getTitle();
  }

  onGridReady(params) {
    params.api.sizeColumnsToFit();
  }

  onEmailChange(): void {
    this.searchValue = this.userEmail.length;
    const validateEmail = (email) => {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };
    let em = validateEmail(this.userEmail);
  }

  getRoles() {
    this.rolesList = [];
    this.restService.getRequest(AppSettings.GETROLES).subscribe({
      next: (response) => {
        const rList = Array.isArray(response?.data) ? response.data : [];
        rList.forEach(roles => {
          this.rolesList.push({
            id: roles.id,
            name: roles.name,
            checked: false
          });
        });
      },
      error: (err) => {
        if (err.error?.message?.length > 0) {
          this.toastr.error(err.error.message, 'Error');
        } else {
          this.toastr.error('Session Expired Please login again.', 'Error');
        }
      }
    });
  }

  getUsers() {
    this.spinner.activate();
    this.usersList = [];
    this.restService.getRequest(AppSettings.GETUSERS).subscribe({
      next: (response) => {
        const uList = Array.isArray(response?.data) ? response.data : [];
        uList.forEach(userz => {
          const obj: any = {
            id: userz.id,
            roles: userz.roles,
            email: userz.email,
            firstName: userz.firstName,
            lastName: userz.lastName
          };
          obj.status = userz.active ? 'Active' : 'Inactive';
          this.usersList.push(obj);
        });

        this.gridOptions = {
        defaultColDef: {
          resizable: true,
          sortable: true,
          filter: true,
          headerClass: "headerClass",
          flex: 1,
          minWidth: 100,
        },
        columnDefs: [
          // { headerName: '#', field: 'sno' },          
          { headerName: 'First Name', field: 'firstName' },
          { headerName: 'Last Name', field: 'lastName' },
          { headerName: 'Email', field: 'email', cellClass: 'copy-text' },
          { headerName: 'Role Name', field: 'roles' },
          { headerName: 'Status', field: 'status' },
          {
            headerName: 'Action', field: 'action', cellRenderer: EditDeleteRendererComponent,
            cellRendererParams: {
              onEditClick: this.onEditClick.bind(this),
              onDeleteClick: this.onDeleteClick.bind(this)
            }
          }
        ],
        rowData: this.usersList,
      };
      },
      error: (err) => {
        if (err.error?.message?.length > 0) {
          this.toastr.error(err.error.message, 'Error');
        } else {
          this.toastr.error('Session Expired Please login again.', 'Error');
        }
      },
      complete: () => this.spinner.deactivate()
    });
  }

  onAddClick() {
    this.action = 'add';
    this.popupHeading = 'Add User';
    this.userEmail = '';
    this.firstName = '';
    this.lastName = '';
    this.savedRoleNames = [];
    this.rolesList.forEach(element => {
      element.checked = false;
    });
    this.modalRef = this.ngbModalService.open(this.aduser);
  }

  private getSelectedRoleIds(): any[] {
    return this.rolesList.filter(role => role.checked).map(role => role.id);
  }

  private getSelectedRoleNames(): string[] {
    return this.rolesList
      .filter(role => role.checked)
      .map(role => (role.name || '').toString().trim())
      .filter(Boolean)
      .sort();
  }

  private haveRolesChanged(): boolean {
    const selectedRoleNames = this.getSelectedRoleNames();
    const previousRoleNames = [...this.savedRoleNames].sort();

    if (selectedRoleNames.length !== previousRoleNames.length) {
      return true;
    }

    return selectedRoleNames.some((roleName, index) => roleName !== previousRoleNames[index]);
  }

  saveUser() {
    const selectedRoles = this.getSelectedRoleIds().map(roleId => String(roleId));
    const validateEmail = (email) => {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };
  
    if (this.firstName.length === 0) {
      this.toastr.error('Please enter first name', 'Error');
      return;
    }
    if (this.lastName.length === 0) {
      this.toastr.error('Please enter last name', 'Error');
      return;
    }
    var em = validateEmail(this.userEmail);   
    if (!em) {
      this.toastr.error('Please enter valid email', 'Error');
      return
    }
    if (selectedRoles.length === 0) {
      this.toastr.error('Please select atleast one role', 'Error');
      return;
    }
    if (this.action == 'add') {
      let model = {
        email: this.userEmail,
        firstName: this.firstName,
        lastName: this.lastName,
        roles: selectedRoles
      }
      if (!this.searchValue) {
        this.toastr.error('Please enter valid email', 'Error');
        return;
      }
      this.spinner.activate();
      this.restService.postRequest(AppSettings.ADDUSER, model).subscribe((response) => {
        if (!response.success) { this.spinner.deactivate(); this.toastr.error('Mail ID Already Exist', 'Error'); }

        if (response.success) {
          this.userEmail = '';
          this.firstName = '';
          this.lastName = '';
          this.savedRoleNames = [];
          this.modalService.dismissAll();
          this.toastr.success('User added successfully', 'Success');
          this.getUsers();
          this.spinner.deactivate();
        }
      }, (err) => {
        this.spinner.deactivate();
        if (err.error.message.length > 0) {
          this.toastr.error(err.error.message, 'Error');
        } else {
          this.toastr.error('Session Expired Please login again.', 'Error');
        }
      })
    }
    if (this.action == 'edit') {
      this.model = {
        id: this.userId,
        email: this.userEmail,
        firstName: this.firstName,
        lastName: this.lastName,
        roles: selectedRoles,
      }

      if ((this.dataBeforeEdit.firstName == this.firstName) &&
        (this.dataBeforeEdit.lastName == this.lastName) &&
        (this.dataBeforeEdit.email == this.userEmail) &&
        !this.haveRolesChanged())  {
        this.toastr.error('No changes found', 'Error');
        return
      } 
      else {
        this.toastr.success('Save successfully', 'Success');
      }

      this.spinner.activate();
      this.restService.putRequest(AppSettings.UPDATEUSER, this.model).subscribe((response: any) => {
        if (response.success) {
          this.userEmail = '';
          this.firstName = '';
          this.lastName = '';
          this.savedRoleNames = [];
          this.modalService.dismissAll();
          this.getUsers();
        }
        this.spinner.deactivate();
      }, (err) => {
        this.spinner.deactivate();
        if (err.error.message.length > 0) {
          this.toastr.error(err.error.message, 'Error');
        } else {
          this.toastr.error('Session Expired Please login again.', 'Error');
        }
      })
    }
    else {
      // this.toastr.error('Please fill Details for Adding New User', 'Error');
    }
  }

  onEditClick(id) {
    this.userEmail = '';
    this.rolesList.forEach(element => {
      element.checked = false;
    });
    this.action = 'edit';
    this.popupHeading = 'Edit User';
    let item = this.usersList.find(item => item.id === id);
    this.dataBeforeEdit = item;
    this.userEmail = item.email;
    this.userId = item.id;
    this.firstName = item.firstName;
    this.lastName = item.lastName;
    this.savedRoles = item.roles;
    this.savedRoleNames = Array.isArray(item.roles)
      ? item.roles.map((role: string) => (role || '').toString().trim()).filter(Boolean)
      : [];
    this.rolesList.forEach(element => {
      this.savedRoleNames.forEach(e => {
        if (e == element.name) {
          element.checked = true;
        }
      })
    });
    this.modalRef = this.ngbModalService.open(this.aduser);
  }

  onDeleteClick(id) {
    let popupData = {
      title: "Delete Confirmation",
      message: "Are you sure you want to delete this item?",
      cancelBtnText: "No",
      confirmBtnText: "Confirm"
    }
    let dialoge = this.ngbModalService.open(ConfirmationDialogueComponent);
    dialoge.componentInstance._data = popupData;
    dialoge.result.then(data => {
      if (data) {
        this.spinner.activate();
        this.restService.deleteUser(AppSettings.DELETEUSER, id).subscribe((response: any) => {
          if (response.success) {
            this.toastr.success('User deleted successfully.', 'Success');
            this.getUsers();
            this.spinner.deactivate();
          }
        }, (err) => {
          this.spinner.deactivate();
          if (err.error.message.length > 0) {
            this.toastr.error(err.error.message, 'Error');
          } else {
            this.toastr.error('Session Expired Please login again.', 'Error');
          }
        })
      }
    });
  }

}
